import { computed, type MaybeRefOrGetter, toValue } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { getNotifications } from '@/features/notifications/api/get-notifications'
import { NOTIFICATIONS_QUERY_KEY } from '@/features/notifications/queries/keys'

/** The caller's newest notifications; only fetched while `enabled` (e.g. the bell menu is open). */
export function useNotifications(enabled: MaybeRefOrGetter<boolean>) {
  return useQuery({
    queryKey: [...NOTIFICATIONS_QUERY_KEY, 'latest'],
    queryFn: () => getNotifications(),
    select: (page) => page.notifications,
    enabled: computed(() => toValue(enabled)),
  })
}
